import styled from 'styled-components';

import { SPACING, COLOR } from '../../../../packages/constants';
import { StyledPlus, StyledMinus, StyledElimination } from '../icons/icons';

export const AccountRow = styled.tr`
    width: 100%;

    ${StyledElimination} {
        margin-right: ${SPACING.X_SMALL};
    }
`;

export const ToggleAccountRow = styled.button`
    margin: 0;
    border: 0;
    background-color: transparent;
    cursor: pointer;
    display: flex;
    align-content: center;
    padding: 0;
    font-weight: 700;
    font-size: inherit;
    line-height: 15px;
    color: ${COLOR.DATAGRID.DATAGRID_TEXT};

    ${StyledPlus},
    ${StyledMinus},
    ${StyledElimination} {
        margin-right: ${SPACING.X_SMALL};
    }

    .icon--toggle-row {
        display: inline-flex;
    }
`;

export type HandleToggleAccountRowFn = (id: string) => void;
